import './ServiceInfoPage.css';

export default function ServiceInfoPage({ serviceName }) {
  return (
    <div className="service-info-page">
      <div className="service-info-card">
        <img src="/Logo.png" alt="CarCure Logo" className="service-info-logo" />

        <h1>Thank You for Choosing CarCure</h1>

        <h2>{serviceName}</h2>

        <p>
          To book an appointment or get more information about service pricing,
          please contact us by phone or email.
        </p>

        <div className="service-contact-list">
          <a href="tel:7053133413">📞 705-313-3414</a>
          <a href="tel:7059912321">📞 705-991-2321</a>
          <a href="mailto:info@carcure.ca">✉ info@carcure.ca</a>
        </div>

        <a href="/" className="back-home-btn">
          Back to Home
        </a>
      </div>
    </div>
  );
}